import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faInfoCircle,
  faLightbulb,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const AdminAccessAlert = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden border border-gray-100">
        {/* Header */}
        <div className="bg-red-50 p-4 flex items-center justify-between rounded-t-2xl">
          <div className="flex items-center space-x-3">
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className="text-red-600 text-2xl"
            />
            <h3 className="text-xl font-semibold text-red-600">
              Unauthorized Access
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} className="text-lg" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-gray-700 mb-4">
            Hi there! It looks like you don't have the necessary permissions to access this resource.
          </p>

          {/* Details */}
          <div className="bg-gray-50 p-4 rounded-xl mb-4 border border-gray-200">
            <div className="flex items-center space-x-3 mb-3">
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="text-blue-500 text-lg"
              />
              <h4 className="text-sm font-medium text-gray-800">Details</h4>
            </div>
            <div className="space-y-2">
              <p className="text-sm text-gray-700">
                <span className="font-medium">Message:</span> Unauthorized Access!
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">Description:</span> Only users with administrative privileges can access this resource. Please contact your system administrator if you believe this is an error.
              </p>
            </div>
          </div>

          {/* Tips */}
          <div className="bg-yellow-50 p-4 rounded-xl mb-4 border border-yellow-200">
            <div className="flex items-center space-x-3 mb-3">
              <FontAwesomeIcon
                icon={faLightbulb}
                className="text-yellow-600 text-lg"
              />
              <h4 className="text-sm font-medium text-gray-800">Tips</h4>
            </div>
            <p className="text-sm text-gray-700">
              If you believe you should have access to this resource, please contact your system administrator for assistance.
            </p>
            <p className="text-sm text-gray-700 mt-2">
              <strong>Tip:</strong> Ensure that you are logged in with the correct account that has administrative privileges.
            </p>
          </div>

          {/* Action Button */}
          <button
            onClick={onClose}
            className="w-full bg-red-600 text-white py-2 px-4 rounded-xl hover:bg-red-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminAccessAlert;
